import { RequestStatus } from 'features/request/requestSlice';
import type { TUseRequestUpdaterProps } from 'features/request/useRequest';
import { useRequest } from 'features/request/useRequest';
import type { UerSetActKc2FormulaMutation } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerSetActKC2FormulaGql } from '../actFormulaQueries';

export const useSetActFormulaValue = ({
    variables,
    onSuccess,
}: {
    variables: { actKC2Id: number; workOrderPriceId: number };
    onSuccess?: (reloadRowsIds?: number[] | null) => void;
}) => {
    const dispatch = useDispatch();

    const onSuccessLocal = useCallback(
        (depsVars: TUseRequestUpdaterProps<UerSetActKc2FormulaMutation>) => {
            onSuccess?.(depsVars?.payload?.uerSetActKC2Formula?.data);
        },
        [onSuccess],
    );

    const [, status, , request] = useRequest({
        requestId: 'uerSetActKC2Formula',
        query: uerSetActKC2FormulaGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const setValueHandler = useCallback(
        (newValue: string | null) => {
            dispatch(
                request({
                    ...variables,
                    formula: newValue,
                }),
            );
        },
        [dispatch, request, variables],
    );

    const isCommiting = status === RequestStatus.FETCHING;

    return {
        setValueHandler,
        isCommiting,
    };
};
